import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { QueryClient } from '@tanstack/react-query';
import { User } from '@bliks-io/contracts';
import { ErrorFallback } from '@/components/error-boundary';
import { Toaster } from '@bliks-io/ui';
import { lazyDevtool } from '@/config/devtools';

const TanStackRouterDevtools = lazyDevtool(() =>
  import('@tanstack/react-router-devtools').then((m) => ({
    default: m.TanStackRouterDevtools
  }))
);

export interface V2RouterContext {
  auth: {
    isAuthenticated: boolean;
    isSuperAdmin: boolean;
    user: User | undefined;
    slug: string;
    accessToken: string;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<V2RouterContext>()({
  component: RootComponent,
  errorComponent: ({ error, reset }) => <ErrorFallback error={error as Error} resetError={reset} />
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster offset={{ bottom: '100px' }} />
      {TanStackRouterDevtools && (
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  );
}
